export default "__VITE_ASSET__RGpAjuT8__"